const {
    __
} = wp.i18n;

export const Overlay = (props) => {

    return (<div className="qube-tools-demo-popup-overlay"></div>)
}
